import { GroupedReleaseNoteI } from 'declarations/interfaces/releaseNotes';
import { useFetchGroupedReleaseNotes } from 'hooks/api/useReleaseNotes';

type useReleaseNotesT = {
  groupedReleaseNotes: GroupedReleaseNoteI[] | null;
  isLoadingGroupedReleaseNotes: boolean;
};

const useReleaseNotes = (): useReleaseNotesT => {
  const groupedReleaseNotesResult = useFetchGroupedReleaseNotes();

  return {
    groupedReleaseNotes: groupedReleaseNotesResult.data ?? null,
    isLoadingGroupedReleaseNotes:
      groupedReleaseNotesResult.isLoading || groupedReleaseNotesResult.isRefetching,
  };
};

export default useReleaseNotes;
